"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.questionsViewModel = questionsViewModel;
const question_1 = require("./question");
function questionsViewModel(questions) {
    return {
        questions: questions.map(question_1.questionViewModel),
        total: questions.length,
    };
}
